<ng-container *ngIf="(cards[0] && cards[0]!.items!.length === 0) || cards.length === 0; else cardList">
  <div class="no-result-message">
    <div>No Result Found!</div>
  </div>
</ng-container>

<ng-template #cardList>
  <div class="clinic-list-container">
    <div class="title">
      <app-label [text]="'Select Clinic:'">
      </app-label>
    </div>

    <div>
      <app-card [items]="cards"></app-card>
    </div>
  </div>
</ng-template>
